export default function Terms() {
  return (
    <div className="py-28 px-6 md:px-10" data-testid="terms-page">
      <div className="max-w-3xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">Legal</div>
        <h1 className="display text-5xl md:text-6xl mt-3 text-ink">Terms of Use</h1>
        <p className="mt-4 text-xs text-ink/50">Effective date: February 2026</p>

        <div className="mt-10 space-y-6 text-ink/75 leading-relaxed font-light">
          <p>
            These Terms of Use ("Terms") govern your use of the Flint Islamic Center website at
            flintislamiccenter.com (the "Website") operated by <strong>Flint Islamic Center</strong> ("FIC"),
            a religious non-profit organization recognized under Section 501(c)(3) of the U.S. Internal Revenue Code.
            By using the Website you agree to these Terms. If you do not agree, please discontinue use.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">1. Purpose of the Website</h2>
          <p>
            The Website exists to serve the Muslim community of the Greater Flint area with prayer times, events,
            religious services, educational content, and to facilitate voluntary donations that support FIC's
            religious, charitable, and educational mission.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">2. Donations</h2>
          <p>
            All gifts made through the Website are <strong>voluntary charitable contributions</strong> to FIC, a
            tax-exempt non-profit under IRS Section 501(c)(3). Contributions are <strong>tax-deductible to the fullest
            extent allowed by U.S. law</strong>. No goods or services are provided to you in exchange for your
            contribution unless explicitly stated at the time of donation.
          </p>
          <p>
            Donations are processed by Stripe. FIC never handles or stores your payment card or bank account
            information directly. A donation receipt will be emailed to the address you provide at the time of
            donation. Please retain it for your tax records.
          </p>
          <p>
            <strong>Recurring donations</strong> will be charged automatically on the frequency you select (daily,
            weekly, monthly, quarterly, or annually) until you cancel. You may cancel a recurring donation at any
            time by contacting the office or replying to any of your donation receipts.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">3. Zakat</h2>
          <p>
            Gifts designated as <em>Zakat</em> are treated as a religious obligation and are
            distributed strictly to eligible recipients per Islamic law (<em>asnaf</em>). By designating a gift as
            Zakat you acknowledge that FIC will distribute it accordingly and will not divert it to general operating
            expenses.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">4. Facility Rentals & In-Person Services</h2>
          <p>
            Facility rentals (Granada Hall, Cordoba Hall, etc.), marriage services (Nikah), and funeral
            arrangements are governed by separate written agreements. Please contact the office for terms,
            availability, and pricing. Content on the Website is informational and does not constitute a contract.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">5. Content & Intellectual Property</h2>
          <p>
            All text, photographs, the FIC logo, Islamic calligraphy, and original artwork on this Website are
            the property of Flint Islamic Center or are used with permission. You may view and share content for
            personal, non-commercial purposes with attribution. Reproduction or republication in any other form
            requires prior written consent.
          </p>
          <p>
            Qur'anic verses are reproduced from widely-accepted translations. Hadith references are cited from
            recognized collections. We strive for accuracy; please contact us if you spot any error.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">6. User Conduct</h2>
          <p>
            When submitting a form, comment, or other content through the Website, you agree not to submit anything
            unlawful, defamatory, abusive, or that violates another person's rights. FIC reserves the right to remove
            any content that violates these Terms or that is inconsistent with the Islamic values of the Center.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">7. Religious Content — No Legal Advice</h2>
          <p>
            Religious information provided by FIC, including answers to questions about Islamic practice, is
            intended for educational purposes only. It does not constitute legal, financial, medical, or
            professional advice. Please consult a qualified professional for matters requiring personal guidance.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">8. Prayer & Iqamah Times</h2>
          <p>
            Athan times are computed using the AlAdhan public API (ISNA method). Iqamah times are maintained by
            FIC staff with best effort. Times may change seasonally, during Ramadan, or for special occasions —
            please verify with the masjid if you are planning to arrive for a specific prayer.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">9. Limitation of Liability</h2>
          <p>
            The Website and its content are provided "as is" and "as available." To the fullest extent permitted by
            law, FIC disclaims all warranties and will not be liable for any indirect, incidental, consequential, or
            punitive damages arising from your use of the Website.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">10. Third-Party Services</h2>
          <p>
            The Website integrates with Stripe (payments), Resend (transactional email), and public Islamic data
            APIs (prayer times, daily verse). Your use of those services is governed by their respective terms and
            privacy policies.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of the State of Michigan, without regard to conflict-of-law
            principles. Disputes will be brought in the courts of Genesee County, Michigan.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">12. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. Material changes will be posted on this page with an
            updated effective date. Your continued use of the Website after the changes take effect means you
            accept the new Terms.
          </p>

          <h2 className="font-serif text-2xl text-ink pt-4">13. Contact</h2>
          <p>
            Flint Islamic Center<br />
            9447 Corunna Rd, Swartz Creek, MI 48473<br />
            (810) 406-2617 ·{" "}
            <a href="mailto:flintislamiccenter@gmail.com" className="text-navy underline">flintislamiccenter@gmail.com</a>
          </p>

          <p className="text-xs text-ink/50 pt-8">Last updated: February 2026</p>
        </div>
      </div>
    </div>
  );
}
